import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import { AdCampaignData } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import moment from 'moment'

import Button from '../../shared/Button'
import LegacySvg from '../../shared/LegacySvg'

const PaidAdCTAActivate = ({
  isLoading,
  disabled,
  onClick,
  campaign,
}: {
  isLoading: boolean | undefined
  disabled: boolean
  onClick: (() => void) | undefined
  campaign: AdCampaignData
}) => {
  return (
    <>
      {campaign.starts_at && campaign.ends_at && (
        <Typography color="textSecondary" paragraph variant="body2">
          {I18n.t('content.facebookCTAMessage', {
            startDate: moment(campaign.starts_at).format('lll'),
            endDate: moment(campaign.ends_at).format('lll'),
          })}
        </Typography>
      )}
      <Button
        style={{
          position: 'relative',
          overflow: 'hidden',
          width: '100%',
        }}
        data-testid={'claimAdFundsFPPAButton'}
        disabled={isLoading || disabled}
        loading={isLoading || undefined}
        onClick={onClick}
        width="large"
      >
        {I18n.t('content.claimAdFunds')}
        <Box
          sx={{
            position: 'absolute',
            bottom: '-1px',
            right: '-1px',
            transition: 'opacity 0.2s ease-out',
            opacity: disabled ? '0.3' : '1',
          }}
        >
          <LegacySvg height={'40px'} symbol={'premium-badge'} width={'40px'} />
        </Box>
      </Button>
    </>
  )
}

// PaidAdCTAActivate.propTypes = {
//   campaign: PropTypes.object,
//   disabled: PropTypes.bool,
//   isLoading: PropTypes.bool,
//   onClick: PropTypes.func,
// }

export default PaidAdCTAActivate
